export default {
  NOTIFICATION_LIVE_LIST_REQUEST: 'APP/NOTIFICATION_LIVE/NOTIFICATION_LIVE_REQUEST',
  NOTIFICATION_LIVE_LIST_SUCCESS: 'APP/NOTIFICATION_LIVE/NOTIFICATION_LIVE_SUCCESS',
  NOTIFICATION_LIVE_LIST_ERROR: 'APP/NOTIFICATION_LIVE/NOTIFICATION_LIVE_ERROR',
};
